import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import SlidingPanel from "react-sliding-side-panel";
import { Button, Box, Input } from "@mui/material";
import "./PolicyDetails.scss";
interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const PolicyDetail: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [pageStatus, setPageStatus] = React.useState<number>(1);

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  return (
    <div>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        onClose={() => {
          value_update(attrName, false);
        }}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => value_update(attrName, false)}>
        <Box className={open_status == true ? "modalInner show" : "modalInner"}>
          <div className="scrollable_area">
            <Grid container spacing={2} className="mb-4">
              <Grid xs={7}>
                <h6 className="policyNumber">
                  Policy <span>#4525/26/25/5454/15</span>
                </h6>
              </Grid>
              <Grid xs={5}>
                <h6 className="Premium">
                  Premium(incl. GST) <span>₹ 4552</span>
                </h6>
              </Grid>
              <Grid xs={12}>
                <div className="quote_div">
                  <Grid container spacing={2}>
                    <Grid xs={3}>
                      <img
                        src="./images/insurerlogo/aditya_birla_capital.svg"
                        alt=""
                        className="insurer"
                      />
                    </Grid>
                    <Grid xs={4}>
                      <h6 className="idv_value">
                        IDV <span>₹ 4552</span>
                      </h6>
                    </Grid>
                    <Grid xs={5}>
                      <h6 className="vehicle_details">
                        Activ Assure - Diamond Plan
                      </h6>
                      <p className="vehicle_no">2 Adults</p>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid xs={6}>
                <h6 className="payment_done">
                  Payment Done <span>14 June,2021</span>
                </h6>
                <p className="journey_space">.</p>
                <p className="journey_space">.</p>
                <p className="journey_space">.</p>
                <p className="journey_space">.</p>
                <h6 className="payment_date mb-0">
                  Policy Start Date <span>20 June,2021</span>
                </h6>
              </Grid>
              <Grid xs={6}>
                <p className="policyCoverHeading">This Policy Covers :</p>
                <ul className="policy_cover">
                  <li>Ambulance Cover</li>
                  <li>Pre-Hospital Cover</li>
                  <li>Post-Hospital Cover</li>
                  <li>Restoration - 100% of Sum Insured</li>
                  <li>OPD Benefit</li>
                  <li>Room Rent - Single Private AC Room</li>
                  <li>Worldwide Emergency Hospitalisation</li>
                  <li>Maternity Cover</li>
                </ul>
              </Grid>
              <Grid xs={6}></Grid>
              <Grid xs={12}>
                <hr />
              </Grid>
              <Grid xs={7}>
                <p className="policyCoverHeading">
                  You were helped by Vishal with your purchase:
                </p>
              </Grid>
              <Grid xs={5}>
                <p className="policyCoverHeading">Rate your experience.</p>
              </Grid>
              <Grid
                xs={12}
                className="ctaBtns mt-5"
                style={{ textAlign: "center" }}>
                <Button variant="contained" className="submitBtn download">
                  Download
                </Button>
              </Grid>
            </Grid>
          </div>
        </Box>
      </SlidingPanel>
    </div>
  );
};

export default PolicyDetail;
